// svg 아이콘의 사이즈를 변환하는 함수
export function convertIconSize(
  size?: number | null,
  defaultSize: { width: number; height: number } = { width: 14, height: 14 },
): { width: number; height: number } {
  const { width, height } = defaultSize
  if (!size) return { width, height }
  const ratio = size / width
  return {
    width: width * ratio,
    height: height * ratio,
  }
}
